import { Component, OnInit } from '@angular/core';
import { SpinnyService } from './spinny.service';

@Component({
  selector: 'app-spinny',
  templateUrl: './spinny.component.html',
  styleUrls: ['./spinny.component.scss']
})
export class SpinnyComponent implements OnInit {
  isVisible = false;

  constructor(private spinnyService: SpinnyService) {}

  ngOnInit() {
    this.spinnyService.setSpinnyVisible.subscribe(isVisible => {
      this.isVisible = isVisible;
    });
  }
}
